import { Suspense } from 'react';
import { SellerTeamClient } from './seller-team-client';

export default function Page() {
  return (
    <Suspense fallback={null}>
      <SellerTeamClient />
    </Suspense>
  );
}
